import { useState } from "react"

export const usePreviewImageDialog = () => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null)

    const openImageModal = (imageUrl: string) => setSelectedImage(imageUrl)
    const closeImageModal = () => setSelectedImage(null)

    return { selectedImage, openImageModal, closeImageModal }
}
